import * as React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Divider } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import { ReactComponent as ToastIcon } from "../../../Assets/Images/ToastIcon.svg";
import { Heading4 } from "../../atoms/Typography/Heading/Heading";
import { FormItemsWrap } from "../../molecules/Wrap/Wrap";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function ConfirmDialog({
  open,
  close,
  title,
  description,
  onOkClick,
  onOkTitle,
  onNoClick,
  onNoTitle,
  onCancelClick,
  onCancelTitle,
  isError,
}) {
  const { t } = useTranslation();
  return (
    <div>
      <BootstrapDialog
        onClose={close}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth={"xs"}
      >
        <div
          style={{
            padding: "24px",
          }}
        >
          <FormItemsWrap direction={"row"} justifyContent={"space-between"}>
            <Heading4 text={title} />
            <IconButton
              aria-label="close"
              onClick={close}
              sx={{
                width: "8px",
                backgroundColor: "transparent",
                "&.MuiButtonBase-root:hover": {
                  bgcolor: "transparent",
                },
                color: "#FF6259",
              }}
            >
              <CloseIcon />
            </IconButton>
          </FormItemsWrap>
          <Divider
            style={{
              paddingTop: "12px",
              marginBottom: "12px",
            }}
          />
          <FormItemsWrap gap={"32px"}>
            <Heading4
              iconAlign={"start"}
              icon={
                isError && (
                  <ToastIcon
                    role="img"
                    type="img"
                    width={"16px"}
                    aria-label="toast Icon"
                    fill={"#FF6259"}
                  />
                )
              }
              text={description}
            />
            <DialogActions>
              {onCancelClick && (
                <Button autoFocus variant="whiteSquare" onClick={onCancelClick}>
                  {onCancelTitle || t("common:action.cancel")}
                </Button>
              )}
              {onNoClick && (
                <Button autoFocus variant="whiteSquare" onClick={onNoClick}>
                  {onNoTitle || t("common:alert-confirm.no")}
                </Button>
              )}
              <Button autoFocus variant="primaryBlue" onClick={onOkClick}>
                {onOkTitle || t("common:action.ok")}
              </Button>
            </DialogActions>
          </FormItemsWrap>
        </div>
      </BootstrapDialog>
    </div>
  );
}
